import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NbIconComponent } from '@nebular/theme';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { OfbizForm, OfbizFormField, OfbizHiddenField } from './ofbiz-form-model';
import { OfbizFormsService } from './ofbiz-forms.service';
import { LookupFieldService } from './ofbiz-lookup-field/lookup-field.service';
import { ActivatedRoute } from '@angular/router';

export enum ActionState {
  FIND = "find",
  ADD = "add",
  EDIT = "edit",
  DELETE = "delete",
  LIST = "list",
  VIEW = "view",
  TEST = "test",
  RELATE = "relate",
  LINK = "link",
  MASTERDETAIL = "master-detail",
  CUSTOM = "custom",
  TASKSACTRSLT = "tasks-action-result"
}

@Component({
  selector: 'ubs-ofbiz-form',
  templateUrl: './ofbiz-forms.component.html',
  styleUrls: ['./ofbiz-forms.component.scss']
})

export class OfbizFormsComponent implements OnInit, OnChanges {
  // @Input() options:any;
  @Input() ofbizForm: OfbizForm;
  @Input() title: string;
  @Input() parameters: any;
  @Input() target: string;

  @Input() isLookup: boolean;
  @Input() state: any;
  @Input() lookupSelectedValue: any;
  /**
   * Field result from dialog lookup
   */
  @Input() lookupFieldResult: any;

  loading = false;


  private destroy$: Subject<void> = new Subject<void>();
  formFields: any[];
  hiddenFields: OfbizFormField<any>[];
  shownFields: OfbizFormField<any>[];
  form: FormGroup;
  // target:string;
  altTargets: any[];
  targets: any;
  appContext: string;
  isMultiPart: boolean;
  payLoad = '';

  // variables for find search results
  result: any[];
  notFound: Boolean;
  resultsOpen: boolean = false;

  action: string;
  workSpaceState: string;
  listForm: any;

  layout: string;
  /**
   * Gets populated if there is a file type field with on onchange event
   * Used in the file-field-preview child component
   */
  selectedFile: File | null = null;


  @ViewChild("resultsChevron", { read: ElementRef }) resultsChevron: NbIconComponent;
  @ViewChild("resultsContainer", { read: ElementRef }) resultsContainer: ElementRef;


  @Output() seachResults = new EventEmitter<any>();
  @Output() resetAction = new EventEmitter<any>();
  @Output() openDialogContainerEvent = new EventEmitter<any>();
  @Output() setFormData = new EventEmitter<any>();
  @Output() submitResult = new EventEmitter<any>();

  constructor(
    private ofbizFormSerive: OfbizFormsService,
    private lookupFieldService: LookupFieldService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["ofbizForm"]) {
      this.targets = this.ofbizForm.targets;
      console.log({ "TrackOfbizForm": this.ofbizForm, target: this.target, targets: this.targets });
      if (this.parameters) {
        console.log({ "TrackDialog": { component: "OfbizFormsComponent", parameters: this.parameters } });
      }


      if (this.altTargets != undefined && this.altTargets != null) {
        this.altTargets = this.ofbizForm.altTargets;
      }


      this.isMultiPart = this.ofbizForm.isMultiPart(this.ofbizForm.getFields());
      // this.viewMode = (this.ofbizForm.viewMode) ? this.ofbizForm.viewMode: "none";
      // console.log({viewMode:this.viewMode});
      if (this.ofbizForm.fields) {
        // console.log(this.ofbizForm.fields);
        this.getFormFields(this.ofbizForm);
      }
      this.appContext = this.ofbizForm.appContext || null;
      this.layout = this.ofbizForm.layout ? this.ofbizForm.layout : "MultiColumn";

    }
    /*    if(changes["state"] && this.state != undefined){
      console.log("The state has changed");
      console.log({State:this.state});
       this.action = this.state["action"];
        if(this.action == "find" ||this.ofbizForm.formAction == "find"){
          this.listForm = this.state["componentConfig"].listForm;
        }
        if(this.ofbizForm.fields && this.ofbizForm.local){
          console.log("getting a local");
          this.getFormFields(this.ofbizForm);
        }else{
          this.getForm({formName:this.ofbizForm.formName,formLocation:this.ofbizForm.formLocation,entityName:this.ofbizForm.entityName});
        }
     } */
    if (changes["parameters"]) {
      console.log({ parameters: this.parameters });
      if (this.allPropertiesHaveValues(this.parameters)) {
        this.getFormFields(this.ofbizForm);
      }

    }

    if (changes["lookupSelectedValue"]) {
      console.log({ TrackLookupSelectedValue: this.lookupSelectedValue });
      this.lookupFieldService.setLookupSelectedValue(this.lookupSelectedValue);
    }
    if (changes["lookupFieldResult"]) {
      console.log({ TrackLookupResult: this.lookupFieldResult });
      this.lookupFieldService.setLookupSelectedValue(this.lookupFieldResult);
    }
    if (changes["state"]) {
      console.log(this.state);
    }
  }

  getFormFields(ofbizForm: OfbizForm): void {
    this.ofbizFormSerive.getFormFields(ofbizForm['fields'])
      .pipe(take(1))
      .subscribe((formFields: OfbizFormField<any>[]) => {
        this.formFields = formFields;
        if (formFields.length > 0) {
          if (this.isLookup) {
            this.addOptionalFields(this.formFields);
          }
          this.hiddenFields = this.formFields.filter(field => field.controlType == 'hidden');
          this.shownFields = this.formFields.filter(field => field.controlType != 'hidden');
        }
        if (this.action == "find") {
          console.log({ "LISTFORM": this.listForm });
          this.formFields.push({
            "name": "formName",
            "value": this.listForm.listFormName,
            "controlType": "hidden"
          });
          this.formFields.push({
            "name": "formLocation",
            "value": this.listForm.listFormLocation,
            "controlType": "hidden"
          });
          const noConditionField = this.formFields.find(field => field.name == "noConditionFind");
          if (noConditionField) {
            noConditionField["value"] = "Y";
          }
        }
        // console.log({formFields:this.formFields});
        this.form = this.ofbizFormSerive.toFormGroup(this.formFields);
        console.log({ FormValueAfterGroup: this.form.value });
        if (this.state != undefined && this.parameters == undefined) {
          if (this.state.selectedValue != undefined) {
            console.log(this.state);
            this.populateSelectedValue(this.state.selectedValue)
          }
        } else if (this.parameters != undefined) {
          console.log({ TrackParameters: this.parameters })
          this.populateSelectedValue(this.parameters)
        } else {
          console.log(this.state);
        }
      });
  }
  /**
   * 1. Adds optional fields to a form.  Only in the case of a lookup form (isLookup = true)
   * 2. Fields are only added for textqbe control types.
   * 3. All optional field control type are set to "hidden"
   * 4. All options are set to "contains"
   *
   * @todo Create select options to set option fields to "START_WITH","EQUALS" etc
   * @param formFields
   */
  addOptionalFields(formFields): void {
    const textqbeFields = formFields.filter((field) => field.controlType === "textqbe");
    textqbeFields.forEach((textField) => {
      console.log({ TrackTextqbeFields: textField });
      const _icname = textField.name + "_ic";
      const _opname = textField.name + "_op";
      this.formFields.push({
        name: _icname,
        value: "Y",
        "controlType": "hidden"
      });
      this.formFields.push({
        name: _opname,
        value: "contains",
        "controlType": "hidden"
      });
    })
  }
  /**
   * 1. Gets the form model from a remote location before calling the getFormFields function
   * 2. Only for forms without a existing local definition
   * 3. This fuction is not recommended and the best practice is to store a local model for the form
   * @param options
   */
  getForm(options: any): void {
    console.log({ GetformOptions: options });
    this.ofbizFormSerive.getForm(options)
      .subscribe((data: any) => {
        this.ofbizForm = data;
        this.getFormFields(this.ofbizForm);
      });

  }




  onSubmit() {
    console.log({ Submitting: "Submitting ......." });
    console.log({ SubmittingTarget: this.target });
    console.log({ SubmittingIsLookup: this.isLookup });
    console.log({ SubmittingFormValue: this.form.value });
    if (this.isLookup || (this.ofbizForm.formAction != undefined && this.ofbizForm.formAction == "select")) {
      console.log("we're NOT submitting Baby")
      this.setFormData.emit(this.form.value);
    } else if (this.targets || this.target) {
      if (this.parameters != undefined) {
        this.target = this.targets.updateTarget;
      } else if (this.action == "add") {
        this.target = this.targets.createTarget;
      } else {
        console.log("this.targets", this.targets)
        this.target = this.targets.createTarget;
      }
      console.log("target", this.target, "parameters", this.parameters);
      this.loading = true;
      // check if there's a form value that's empty while it has a value in the route params
      this.populateBlanksWithParams();
      console.log({ formValueOnSubmit: this.form.value });
      const formData = this.convertFormValueToFormData(this.form.value);
      console.log(formData);
      // Debugging: Check if the file field exists
      if (formData.has("file")) {
        console.log("File included:", formData.get("file"));
      } else {
        console.log("No file included in FormData.", formData);
        console.log(this.selectedFile)
      }
      for (const pair of formData.entries()) {
        console.log(pair[0], pair[1]); // Logs the key-value pairs
      }

      this.ofbizFormSerive.postFormData(formData, this.appContext, this.target, this.isMultiPart)
        .pipe(takeUntil(this.destroy$))
        .subscribe((response: any) => {
          console.log(response);
          const statusCode = response.statusCode;
          switch (statusCode) {
            case 200:

              if (response.successMessage == "OK") {
                const data = response.data;
                if (data.eventReturn == "success") {
                  // this.loading = false;
                  const result = data.result;
                  this.resetAction.emit("list");
                  this.submitResult.emit(result);
                }
              }
              break;
            case 404:

              break;
            case 500:

              break;

            default:
              break;
          }
        });
    }

    this.loading = false;


    // console.log({TrackSubmit:{target:this.target,altTarget:this.altTargets,ofbizFormOnSubmit:this.ofbizForm,action:this.action}})
    /* console.log({target:this.target});
    console.log({altTarget:this.altTargets});
    console.log({ofbizFormOnSubmit:this.ofbizForm});
    console.log({action:this.action}); */





  }

  populateSelectedValue(selectedValue: any) {
    // ensure that route parameters are not over ridden
    selectedValue = this.populateParametersFromRoute(selectedValue);
    // console.log({TrackPopulateSelectedValue:selectedValue})
    Object.keys(this.form.controls).forEach(key => {
      // this.form.controls[key].markAsDirty();
      // console.log({FieldToBePopulated:this.form.controls[key]});
      if (selectedValue[key] != undefined) {
        console.log({ PatchValueFor: this.form.controls[key], value: selectedValue[key] });
        this.form.controls[key].patchValue(selectedValue[key]);
        // this.form.controls[key].touched;
      }
      // console.log(key);
    });
    // Patch route params
    this.route.paramMap.pipe(take(1)).subscribe((params) => {
      console.log(params, this.parameters);
      const paramObj: { [key: string]: string } = {};
      params.keys.forEach((key) => {
        if (this.parameters[key] && this.form.controls[key]) {
          this.form.controls[key].patchValue(params.get(key));
        }
      });
    });
    console.log({ FormValue: this.form.value });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    // this.subscription.unsubscribe();
  }

  convertFormValueToFormData(formValue: any): FormData {
    console.log(this.selectedFile);
    const formData = new FormData();
    /* Object.entries(formValue).forEach(([key, value]) => {
      formData.append(key,formValue[key]);
    }); */

    Object.entries(formValue).forEach(([key, value]) => {
      console.log(`Processing key: ${key}, Value:`, value); // Debugging output
      if (value instanceof File) {
        // Ensure that the value is a File before appending
        console.log(`Appending file: ${value.name}`); // Debugging file append
        console.log(`File value: ${value}`);
        const fileValue: File = value;
        console.log(`File value: ${fileValue.size}`);
        // formData.append(key, value, value.name);
        formData.append("uploadedFile", this.form.controls["uploadedFile"].value, value.name);
      } else if (value !== null && value !== undefined) {
        // Append other fields only if they are not null or undefined
        console.log(`Appending field: ${key} = ${value}`);
        formData.append(key, value.toString());
      }
    });
    // formData.append("uploadedFile",this.form.controls["uploadedFile"].value);

    return formData
  }
  /**
   * @comment 1. listens for the openLookupDialog event
   * 2. Emits data to a receiving container, which could be either an edit or create/add container
   * 3. The receiving container then opens the LookupDialogContainerComponent
   * 4. The receiving container acts as broker between the form and the LookupDialogContainerComponent
   * @param data received with the event, normally the field propeties
   */
  openFieldDialog(data): void {
    console.log({ TrackDialog: { component: "OfbizFormsComponent", data: data } });
    this.openDialogContainerEvent.emit(data);
  }

  handleUpload(e) {
    const file = new File([e], e.name)
    this.selectedFile = file;
    console.log(e);
    this.form.controls["uploadedFile"].setValue(file);
  }

  populateParametersFromRoute(selectedValue) {
    console.log(selectedValue);
    this.route.paramMap.pipe(take(1)).subscribe((params) => {
      console.log(params, this.parameters);
      const paramObj: { [key: string]: string } = {};
      params.keys.forEach((key) => {
        console.log(key)
        if (selectedValue[key] != null && selectedValue[key] != undefined) {
          selectedValue[key] = params.get(key);
        } else if (this.parameters[key] != undefined) {
          selectedValue[key] = params.get(key);
        }
      });

    });
    return selectedValue;
  }

  allPropertiesHaveValues<T extends Record<string, any>>(obj: T): boolean {
    return Object.values(obj).every(value => value !== null && value !== undefined && value !== "");
  }

  populateBlanksWithParams() {
    this.route.paramMap.pipe(take(1)).subscribe((params) => {
      const paramObj: { [key: string]: string } = {};
      params.keys.forEach((key) => {
        if (this.form.get(key)) {
          console.log(key);
          this.form.controls[key].patchValue(params.get(key));
        } else {
          console.log("Key not there: " + key)
        }
      });
    });
  }

}
